<template>
  <!--机构设置-->
    <div class="content Institutions">
      <div class="layui-fluid">
        <div class="layui-row">
          <div class="layui-col-md12">
            <!--面包屑-->
            <div class="layui-row">
              <div class="layui-col-md8">
                <span class="layui-breadcrumb" lay-separator=">">
                  <a href="">机构设置</a>
                  <a href="">机构信息</a>
                </span>
              </div>
            </div>
            <div class="layui-row" style="margin-top: 20px">
              <div class="layui-col-md12">
                <div class="layui-card">
                  <div class="layui-card-header">机构基本信息</div>
                  <div class="layui-card-body">
                    卡片式面板面板通常用于非白色背景色的主体内<br>
                    从而映衬出边框投影
                  </div>
                </div>
                <div class="layui-card">
                  <div class="layui-card-header">机构公开联系方式</div>
                  <div class="layui-card-body">
                    卡片式面板面板通常用于非白色背景色的主体内<br>
                    从而映衬出边框投影
                  </div>
                </div>
                <div class="layui-card">
                  <div class="layui-card-header">机构联系人</div>
                  <div class="layui-card-body">
                    卡片式面板面板通常用于非白色背景色的主体内<br>
                    从而映衬出边框投影
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "Institutions",
      data(){
        return {
          msg:''
        }
      },
      methods:{
        // 公共方法
        handlePublics(){
          let _this=this;
          this.$nextTick(()=>{
            layui.use(['jquery','element','table','form'],function () {
              var $ = layui.jquery;
              var element = layui.element;
              var form = layui.form
              var table = layui.table;
              element.render();
              form.render();
              table.render();
            })
          })
        }
      },
      mounted() {
        // 公共方法
        this.handlePublics();
      },
      updated() {
        // 公共方法
        this.handlePublics();
      }
    }
</script>

<style scoped>

</style>
